<template>

      <v-container>
    
      
                    <div class="text-center ma-4">
                             <img :src="$store.state.systemlogo" height="90px"/>
                    </div>
                   <v-card elevation="0" style="min-width: 350px; max-width: 650px;" class="mx-auto">
                    

                            <v-card-text>

                               <p class="text-center text-h4">
                              Welcome to Zera Service Traker
                            </p>
                           <p class="text-center">
                                  We love to keep you updated!
                            </p>
                              <v-divider  class="mt-4 mb-4"/>
                             <v-text-field
                            v-model="number"
                              label="Enter Service Number"
                              placeholder="Enter Service Number"
                              filled
                              rounded
                              solo
                              @change="ViewJob()"
                              append-outer-icon="mdi-file-find"
                            ></v-text-field>

                           
                            </v-card-text>
                    </v-card>
      </v-container>         
   </template>
   <script>
   import {
     mapMutations
   } from 'vuex'
     export default {
       data: () => ({
          number:""
       }),
       beforeCreate: function () {
        this.setLoggedIn(false) 
       },
       created() {
        this.setLoggedIn(false) 
       
       },
       computed:{
        
       },
       methods: {
         ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn','setVariables']),
       
        ViewJob(){
            this.$router.push('/view-job/'+this.number)
        }
       }
     }
   </script>